import request from '@/utils/request'

// 安装axios作为vue插件
export default ({
  install: function (Vue, options) {
    Vue.prototype.$http = request
    Vue.http = request
  }
})
